<template>
  <div class="row">
    <div class="col-lg-3 filters-wrapper">
      <div class="filters">
        <div class="block block-fx-pop block-mode-loading-oneui filter pb-3" v-for="filter in filters" :key="filter.key">
          <div class="block-header block-header-default">
            <h3 class="block-title">
              {{ filter.name }}
              <i
                v-if="filter.key == 'url'"
                class="fas fa-question-circle ml-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Wil jij snel zien waar jij al links geplaatst hebt? Selecteer een site naar keuze en bekijk of deze al op desbetreffende startpagina staat. Een H staat voor homepagina en een D staat voor de dochterpagina."
                data-original-title="Wil jij snel zien waar jij al links geplaatst hebt? Selecteer een site naar keuze en bekijk of deze al op desbetreffende startpagina staat. Een H staat voor homepagina en een D staat voor de dochterpagina."
              ></i>
            </h3>
          </div>
          <div class="block-content p-0">
            <div class="input-group input-group-sm bg-white" v-if="filter.key == 'url'">
              <input
                type="text"
                class="form-control form-control-alt bg-white border-0 pr-0"
                placeholder="Zoeken.."
                v-model="filter.search"
                v-on:keyup="toggleFilterSearch(filter.key, $event)"
              />
              <div class="input-group-append">
                <span class="input-group-text bg-white border-0">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>

            <div class="dropdown-item" v-for="data in filter.visible" :key="data.value" v-on:click.stop.prevent="toggleFilter(filter.key, data)">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="data.value"
                  :name="data.value"
                  :checked="isSelectedFilter(filter.key, data.value)"
                  v-on:change.prevent="toggleFilter(filter.key, data)"
                />
                <label class="custom-control-label d-flex align-items-baseline" :for="data.value"
                  >{{ data.name | capitalize }}
                  <i
                    class="fas fa-question-circle ml-2"
                    v-if="data.tooltip"
                    data-toggle="tooltip"
                    data-placement="top"
                    :title="data.tooltip"
                    :data-original-title="data.tooltip"
                  ></i>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block block-fx-pop pb-3">
        <div class="block-header block-header-default">
          <h3 class="block-title">
            Dochtersheet
          </h3>
        </div>
        <div class="block-content">
          Bekijk <a href="/dochters.xlsx" download>hier</a> alle dochterpagina’s in een excel-sheet!
        </div>
      </div>
    </div>
    <div class="col-lg-9">
      <div class="block">
        <div class="block-header block-header-default">
          <h3 class="block-title">Alle startpagina’s</h3>
        </div>
        <div class="block-content">
          <bs-table
            preset_column="home_price"
            preset_direction="asc"
            :columns="[
              {
                name: 'Website',
                key: 'name',
                class: 'font-w700',
                sort: true,
              },
              {
                name: 'IP ADRES',
                key: 'ip_address',
                sort: true,
              },
              {
                name: 'BL',
                key: 'stat.bl',
                sort: true,
                tooltip: 'Aantal backlinks',
                class: 'd-table-cell d-lg-none',
              },
              {
                name: 'IP',
                key: 'stat.ip',
                sort: true,
                tooltip: 'Aantal backlinks vanaf een uniek IP adres',
              },
              {
                name: 'RD',
                key: 'stat.rd',
                sort: true,
                tooltip: 'Aantal verwijzende domeinnamen (Referring Domains)',
              },
              {
                name: 'PA',
                key: 'stat.pa',
                sort: true,
                tooltip: 'Page Authority',
              },
              {
                name: 'DA',
                key: 'stat.da',
                sort: true,
                tooltip: 'Domain Authority',
              },
              {
                name: 'TF',
                key: 'stat.tf',
                sort: true,
                tooltip: 'Trust Flow',
              },
              {
                name: 'CF',
                key: 'stat.cf',
                sort: true,
                tooltip: 'Citation Flow',
              },
              {
                name: 'Prijs',
                key: 'home_price',
                sort: true,
                tooltip: 'Jaarlijkse prijs. Indien u gebruikerskorting heeft, wordt deze in de winkelwagen verrekend',
              },
              {
                name: 'Aanbieding',
                key: 'home_price_discount',
                sort: true,
              },
              {
                name: 'Live',
                key: 'found',
                sort: true,
              },
              {
                name: 'Acties',
                key: 'id',
                class: 'text-center',
              },
            ]"
            :data="data"
          >
            <template v-slot:Website="{ props }">
              <a
                :href="`https://www.${props.name}`"
                class="link-fx"
                target="_blank"
                data-toggle="tooltip"
                data-placement="top"
                data-html="true"
                :title="
                  $_.uniq(props.links.map((link) => getDomainFromUrl(link.url)))
                    .slice(0, 14)
                    .join('<br />')
                "
                :data-original-title="
                  $_.uniq(props.links.map((link) => getDomainFromUrl(link.url)))
                    .slice(0, 14)
                    .join('<br />')
                "
              >
                {{ props.name | capitalize }}
              </a>
              <span v-if="props.site_badge" class="badge badge-pill badge-info ml-2">{{ props.site_badge }}</span>
            </template>
            <template v-slot:Prijs="{ props }">
              <del v-if="props.home_price_discount">
                {{ props.home_price | currency }}
              </del>
              <span v-else>
                {{ props.home_price | currency }}
              </span>
            </template>
            <template v-slot:Aanbieding="{ props }">
              <span class="badge badge-success" v-if="props.home_price_discount">{{ props.home_price_discount | currency }}</span>
            </template>
            <template v-slot:Live="{ props }">
              <span v-if="props.found" class="font-size-sm font-w600 px-2 py-1 rounded bg-success-light text-success">
                <template v-if="props.found_home && props.found_daughter">
                  HD
                </template>
                <template v-else-if="props.found_home">
                  H
                </template>
                <template v-else-if="props.found_daughter">
                  D
                </template>
              </span>
              <span v-else-if="selectedFilters.url === null"></span>
              <span v-else class="font-size-sm font-w600 px-2 py-1 rounded  bg-danger-light text-danger">
                <i class="fa fa-times"></i>
              </span>
            </template>
            <template v-slot:Acties="{ props }">
              <a
                :href="$route('links.add_single', { site_id: props.id })"
                class="btn btn-sm btn-success"
                data-toggle="tooltip"
                data-placement="top"
                data-original-title="Link toevoegen"
              >
                <i class="fas fa-cart-plus mr-1"></i> Bestellen
              </a>
            </template>
          </bs-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Fuse from 'fuse.js';

export default {
  props: ['sites'],
  data: () => {
    return {
      data: [],
      selectedFilters: {
        url: null,
        user_package_id: true,
      },
      filters: {
        url: {
          search: '',
          key: 'url',
          name: 'Linkchecker',
          data: [],
          visible: [],
        },
        user_package_id: {
          key: 'user_package_id',
          name: 'Toon links uit linkpakket',
          visible: [
            {
              value: true,
              name: 'Ja',
            },
            {
              value: false,
              name: 'Nee',
            },
          ],
        },
      },
    };
  },
  watch: {
    selectedFilters: {
      handler: function() {
        var sites = JSON.parse(JSON.stringify(this.data));
        sites.map((site) => {
          site.found = false;
          site.found_home = false;
          site.found_daughter = false;

          if (this.selectedFilters.url) {
            var links = site.links
              .filter((link) => {
                if (!this.selectedFilters.user_package_id) {
                  return !link.user_package_id;
                }

                return true;
              })
              .filter((link) => link.url.includes(this.selectedFilters.url));

            if (links.length > 0) {
              links.forEach((link) => {
                site.found = true;

                if (link.page_type === 'home') {
                  site.found_home = true;
                }

                if (link.page_type === 'daughter') {
                  site.found_daughter = true;
                }
              });
            }
          }

          return site;
        });

        this.data = sites;
      },
      deep: true,
    },
  },
  created: function() {
    this.data = this.sites;
    this.data.forEach((site) => {
      site.links.forEach((link) => {
        var url = this.getDomainFromUrl(link.url);
        this.filters.url.data.push({
          value: url,
          name: url,
        });
      });
    });
    this.filters.url.data = _.uniqBy(this.filters.url.data, 'value');
    this.filters.url.visible = this.filters.url.data.sort((a, b) => a.name.localeCompare(b.name));
  },
  methods: {
    isSelectedFilter: function(key, value) {
      return this.selectedFilters[key] === value;
    },

    toggleFilterSearch(filter, event) {
      if (event.target.value) {
        var fuse = new Fuse(this.filters[filter].data, {
          threshold: 0.2,
          includeScore: false,
          useExtendedSearch: true,
          keys: ['name'],
        });
        this.filters[filter].visible = fuse.search(event.target.value).map((result) => {
          return result.item;
        });
      } else {
        this.filters[filter].visible = this.filters[filter].data;
      }
    },

    toggleFilter(filter, filterobj) {
      if (this.isSelectedFilter(filter, filterobj.value)) {
        Vue.set(this.selectedFilters, filter, filter == 'user_package_id' ? true : null);
      } else {
        Vue.set(this.selectedFilters, filter, filterobj.value);
      }
    },

    getDomainFromUrl: function(url) {
      const { host } = new URL(url);
      return host.split('.').length > 2
        ? host
            .split('.')
            .splice(1)
            .join('.')
        : host;
    },
  },
};
</script>
<style lang="scss" scoped>
.filters-wrapper {
  .search-wrapper {
    height: 80px;
    background: white;
    padding: 0 30px;
    border: 1px solid #eaeaea;
    border-radius: 40px;

    .tags {
      .tag {
        height: 40px;
        padding: 0 15px;
        margin: 0 10px 0 0;
        background: #de7a01;
        color: white;
        border-radius: 6px;
        line-height: 40px;
        font-size: 14px;
        font-weight: bold;
        transition: background 0.3s ease;

        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }

    input {
      height: 70px;
      font-size: 20px;
      border: none;
      outline: none;

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }

  .filters {
    .filter {
      .block-content {
        max-height: 250px;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
  }
}
</style>
